export const pushUpsaleForApp = async (id, email) => {
  if (!id || !email) return;

  // Разглаживаем массив на один уровень и фильтруем ложные значения
  const course_ids = Array.isArray(id)
    ? id.flat().filter(Boolean)
    : [];

  // console.log('id', course_ids);
  if (course_ids.length === 0) return;

  const data = {
    email: email,
    course: course_ids
  };

  const response = await fetch(import.meta.env.VITE_UPSALE_REG_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text);
  }
}
